import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "mc-stepper__list" }
const _hoisted_3 = ["aria-current", "aria-label", "title"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  class: "mc-stepper__indicator",
  "aria-hidden": "true"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mc-stepper__detail" }
const _hoisted_8 = { class: "mc-stepper__title" }
const _hoisted_9 = { class: "mc-stepper__label" }
const _hoisted_10 = {
  class: "mc-stepper__indicator",
  "aria-hidden": "true",
  style: {"cursor":"pointer"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "mc-stepper__detail" }
const _hoisted_13 = { class: "mc-stepper__title" }
const _hoisted_14 = { class: "mc-stepper__label" }

import { computed } from 'vue';
import MIcon from '../icon/MIcon.vue';

export type Step = {
  id: string | number;
  label: string;
  tooltip?: string;
  isValid?: boolean;
};

type StepperAccessibilityLabels = {
  stepperDescription: string;
  validatedLabel: string;
  currentLabel: string;
  disabledLabel: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MStepperV2',
  props: /*@__PURE__*/_mergeModels({
    steps: {},
    accessibilityLabels: { default: () => ({
      stepperDescription: 'this is a stepper',
      validatedLabel: 'step validated',
      currentLabel: 'current step',
      disabledLabel: 'step disabled',
    }) },
    clickable: { type: Boolean, default: false },
    compact: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["clickOnStep"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const modelValue = _useModel<T['id']>(__props, "modelValue");
const props = __props;

const currentIndex = computed(() =>
  props.steps.findIndex((step) => step.id === modelValue.value),
);

const classObject = computed(() => ({
  'mc-stepper--compact': !!props.compact,
  'mc-stepper--shrinked': props.steps.length > 3,
}));

const isStepValidated = (step: T, index: number) => {
  if (step.isValid !== undefined) {
    return step.isValid;
  }

  return index < currentIndex.value;
};

const isCurrentStep = (step: T) => {
  return modelValue.value === step.id;
};

const stepDescription = (step: T, index: number) => {
  return `#${index + 1} ${step.label}, ${stepStateLabel(step, index)}`;
};

const stepStateLabel = (step: T, index: number) => {
  return isStepValidated(step, index)
    ? props.accessibilityLabels.validatedLabel
    : isCurrentStep(step)
      ? props.accessibilityLabels.currentLabel
      : props.accessibilityLabels.disabledLabel;
};

const onClickOnStep = (step: T) => {
  emit('clickOnStep', step.id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["mc-stepper", classObject.value]),
    "aria-label": props.accessibilityLabels.stepperDescription
  }, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `mc-stepper__item-${index}`,
          class: _normalizeClass(["mc-stepper__item", {
          'mc-stepper__item--validated': isStepValidated(step, index),
          'mc-stepper__item--current': step.id === modelValue.value,
        }]),
          "aria-current": isCurrentStep(step) ? 'step' : false,
          "aria-label": stepDescription(step, index),
          title: step.tooltip,
          style: _normalizeStyle(`--steps: ${_ctx.steps.length}; --current: ${index + 1};`)
        }, [
          (_ctx.clickable)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                class: "mc-stepper__link",
                onClick: _withModifiers(($event: any) => (onClickOnStep(step)), ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  (step.id === modelValue.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(index + 1), 1))
                    : (isStepValidated(step, index))
                      ? (_openBlock(), _createBlock(MIcon, {
                          key: 1,
                          name: "NotificationAvailable16",
                          class: "mc-stepper__icon"
                        }))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(index + 1) + " / " + _toDisplayString(_ctx.steps.length), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(step.label), 1)
                ])
              ], 8, _hoisted_4))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_10, [
                  (isCurrentStep(step))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(index + 1), 1))
                    : (isStepValidated(step, index))
                      ? (_openBlock(), _createBlock(MIcon, {
                          key: 1,
                          name: "NotificationAvailable16",
                          class: "mc-stepper__icon"
                        }))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(index + 1) + " / " + _toDisplayString(_ctx.steps.length), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(step.label), 1)
                ])
              ], 64))
        ], 14, _hoisted_3))
      }), 128))
    ])
  ], 10, _hoisted_1))
}
}

})